import {
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function DebugPanel(props) {
  return (
    <Drawer
      open={props.openDebugPanel}
      anchor="right"
      PaperProps={{
        sx: {
          backgroundColor:
            sessionStorage.getItem("mode") === "light"
              ? "#FFFFFF"
              : "#000000",
          border: 0,
          margin: "60px 12px 12px",
          borderRadius: "12px",
          height: "calc(100% - 84px)",
          boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
          // width: mini ? '64px' : drawerWidth,
        },
      }}
      sx={{
        width: window.innerWidth * 0.33,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width:
            window.innerWidth < 600
              ? "calc(100% - 24px)"
              : window.innerWidth * 0.33,
          boxSizing: "border-box",
        },
      }}
    >
      <DrawerHeader
        sx={{
          position: "fixed",
          background: "#fff",
          borderRadius: "24px 24px 0 0",
          width: "inherit",
          margin: 0,
          borderBottom: "1px solid #ccc",
          zIndex: 999,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            margin: 2,
            fontFamily: "Roboto Condensed",
            fontWeight: 600,
            width: "100%",
          }}
        >
          <ManageSearchIcon
            sx={{ mr: 2, fontSize: 24, verticalAlign: "middle" }}
          />
          Debug
        </Typography>
        <IconButton onClick={props.handleDebugPanelClose}>
          {<CloseIcon />}
        </IconButton>
      </DrawerHeader>
      <div style={{ paddingTop: 70, overflowY: 'auto', height: 'calc(100% - 70px)' }}>
        {props.debugDrawerContent}
      </div>
    </Drawer>
  )
}